<template>
    <svg
        width="24"
        height="22"
        viewBox="0 0 24 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.6667 13.4367L23.2738 15.5994C23.71 15.8045 24 16.3336 24 16.9255V21.6702C24 21.8515 23.8508 21.9983 23.6667 21.9983H23C22.8158 21.9983 22.6667 21.8515 22.6667 21.6702C22.6667 21.6702 22.6812 16.7803 22.6667 16.7483L18.6667 14.8907V21.6702C18.6667 21.8515 18.5175 21.9983 18.3333 21.9983H17.6667C17.4825 21.9983 17.3333 21.8515 17.3333 21.6702V12.2415L14.6667 10.6665V5.20772L12 2.58272L9.33333 5.20772V10.6665L6.66667 12.2415V21.6702C6.66667 21.8515 6.5175 21.9983 6.33333 21.9983H5.66667C5.4825 21.9983 5.33333 21.8515 5.33333 21.6702V14.8907L1.33333 16.7483C1.31875 16.7803 1.33333 21.6702 1.33333 21.6702C1.33333 21.8515 1.18417 21.9983 1 21.9983H0.333333C0.149167 21.9983 0 21.8515 0 21.6702V16.9255C0 16.3336 0.29 15.8045 0.72625 15.5994L5.33333 13.4371V12.2415C5.33318 11.7805 5.57883 11.3532 5.98042 11.116L8 9.92329V5.20731C8 4.8595 8.14042 4.52563 8.39042 4.27954L11.5288 1.19065C11.6588 1.06228 11.8296 0.998291 12 0.998291C12.1704 0.998291 12.3412 1.06228 12.4712 1.19065L15.6092 4.27954C15.8596 4.52563 16 4.8595 16 5.20772V9.92329L18.0196 11.116C18.4208 11.3535 18.6667 11.7805 18.6667 12.2415V13.4367ZM9.33333 16.8611C9.33333 15.4899 10.3512 14.2656 11.7379 14.1356C13.3283 13.9863 14.6667 15.2135 14.6667 16.7483V21.6702C14.6667 21.8515 14.5175 21.9983 14.3333 21.9983H13.6667C13.4825 21.9983 13.3333 21.8515 13.3333 21.6702V16.7483C13.3333 15.9518 12.6087 15.3189 11.7746 15.4538C11.1192 15.5605 10.6667 16.1679 10.6667 16.8221V21.6702C10.6667 21.8515 10.5175 21.9983 10.3333 21.9983H9.66667C9.4825 21.9983 9.33333 21.8515 9.33333 21.6702V16.8611Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "ChurchIcon",
});
</script>
